<template>
  <v-footer
    id="home-footer"
    color="grey darken-4"
    dark
    min-height="60"
  >
    <v-container>
      <v-row>
        <v-col
          class="text-center"
          cols="12"
        >
          Copyright &copy; 2020 Lithos Co., Ltd.
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
